import { Spinner } from "@nextui-org/react";
import { ReactNode } from "react";

import { PERMISSIONS_BAN_TYPES } from "@/constants";
import { Banned } from "@/pages/Banned";
import { UnauthorizedAccess } from "@/pages/UnauthorizedAccess";
import useAuth from "@/services/useAuth";
import { getIsPartner } from "@/utils/getIsPartner";

interface ProtectedRoutesProps {
  element: ReactNode;
  permission?: string;
  fallbackPath?: string;
  permissionRequired?: boolean;
}

export default function ProtectedRoutes({ element, permission, permissionRequired = true }: ProtectedRoutesProps) {
  const isPartner = getIsPartner();
  const { isLoading: isAuthLoading, permissions } = useAuth();
  if (!isPartner && permissions?.length === 0) {
    return element;
  }
  // Identify whether we should wait for the permissions to load or not
  if (!permissions || permissions?.length === 0 || isAuthLoading) {
    return <Spinner />;
  }
  const isLimitedAccessBan = permissions?.includes(PERMISSIONS_BAN_TYPES.limited_access);
  // Check if the user has the required permissions
  const hasPermissions = permissions?.includes(permission ?? "");

  if (hasPermissions || !permissionRequired) {
    return element;
  } else {
    return isLimitedAccessBan ? <Banned banType={PERMISSIONS_BAN_TYPES.limited_access} /> : <UnauthorizedAccess />;
  }
}
